module.exports = __webpack_public_path__ + "static/img/partner4.4c6d717.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/partner4.png
// module id = 3n3f
// module chunks = 0